import { render, staticRenderFns } from "./RequestManagement.vue?vue&type=template&id=ea73c53a&"
import script from "./RequestManagement.vue?vue&type=script&lang=js&"
export * from "./RequestManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports